
import { Vue, Component } from "vue-property-decorator";

@Component
export default class vFooter extends Vue {
  get year() {
    return new Date().getFullYear();
  }
}
